import axios from 'axios';
import { LOGOUT } from '../../constants/endpoints';

const logoutApiCall = ({ email, sessionToken, deviceId }) => {
  return axios.post(LOGOUT(), {
    email,
    sessionToken,
    deviceId,
  });
};

export default logoutApiCall;
